import * as React from "react"
import { cn } from "@/lib/utils"

/** Status is always a dot plus a text label — never color alone (rule 1, and a11y). */
const STATUS = {
  draft:     { label: "Draft",     dot: "bg-status-draft",   text: "text-ink-muted" },
  sent:      { label: "Sent",      dot: "bg-status-sent",    text: "text-status-sent" },
  paid:      { label: "Paid",      dot: "bg-status-paid",    text: "text-status-paid" },
  accepted:  { label: "Accepted",  dot: "bg-status-paid",    text: "text-status-paid" },
  active:    { label: "Active",    dot: "bg-status-paid",    text: "text-status-paid" },
  completed: { label: "Completed", dot: "bg-status-draft",   text: "text-ink-muted" },
  paused:    { label: "Paused",    dot: "bg-status-overdue", text: "text-ink-muted" },
  overdue:   { label: "Overdue",   dot: "bg-status-overdue", text: "text-status-overdue" },
  rejected:  { label: "Rejected",  dot: "bg-status-overdue", text: "text-status-overdue" },
  locked:    { label: "Locked",    dot: "bg-status-draft",   text: "text-ink-muted" },
  unlocked:  { label: "Unlocked",  dot: "bg-status-paid",    text: "text-status-paid" },
}

function StatusDot({ status, className, ...props }) {
  const s = STATUS[status] ?? { label: status, dot: "bg-status-draft", text: "text-ink-muted" }
  return (
    <span className={cn("inline-flex items-center gap-2 text-small", s.text, className)} {...props}>
      <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", s.dot)} aria-hidden="true" />
      {s.label}
    </span>
  )
}

export { StatusDot, STATUS }
